import { render, staticRenderFns } from "./announcememt-new.vue?vue&type=template&id=64a5e4ea&scoped=true"
import script from "./announcememt-new.vue?vue&type=script&lang=js"
export * from "./announcememt-new.vue?vue&type=script&lang=js"
import style0 from "./announcememt-new.vue?vue&type=style&index=0&id=64a5e4ea&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64a5e4ea",
  null
  
)

export default component.exports